import { Box, Typography } from '@mui/material'
import { useComponentSizeAndPosition } from '../shared/utils'
import { NavBar } from './Navigation'

export function Guide() {
  const isMobile = window.innerWidth < 768

  return <GuideMobile />
}

function GuideMobile() {
  const { boxRef, width, height } = useComponentSizeAndPosition()
  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100vdh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* {width && height && (
      <DVD
        containerHeight={height}
        containerWidth={width}
        initialX={width - 75}
        initialY={height - 120}
        radius={120}
        text="Big yellow button"
      />
    )} */}
      <Box
        sx={{
          padding: '10px',
          bottom: 0,
          width: '100%',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 1.0)',
        }}
      >
        <NavBar direction="row" />
      </Box>

      <Typography variant="body1" paragraph>
        Coming soon!
      </Typography>
    </Box>
  )
}

function GuideDesktop() {
  return <div>GuideDesktop</div>
}
